import React from "react";
import BannerListPage from "features/MarketingBanner/presentation/pages/BannerList";

function BannerListScreen() {
  return <BannerListPage />;
}

export default BannerListScreen;
